module.exports = __webpack_public_path__ + "static/media/001.6666f010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/001.jpg
// module id = 545
// module chunks = 0